import React, { memo } from 'react'
import Tooltip from 'react-wot-bootstrap/lib/components/Tooltip/Tooltip'

import {
    TASK_COMPLETE_PREVIOUS,
    TASK_NOT_AVAILABLE,
    DONE,
    DONE_DESCRIPTION,
    TASK_TAKE_PREV_REWARD,
    PENDING,
} from './translations'

import { QUEST_STATUSES } from '../clan_quests_constants'
import PropTypes from 'prop-types'
import styles from './ClanSupplyTooltips.scss'

const QuestStatusTooltip = memo(({
    id,
    isAvailable,
    previousRewardsSum,
    isLockedByPreviousCycle,
    status,
}) => {

    if (status === QUEST_STATUSES.COMPLETE) return null

    if (status === QUEST_STATUSES.REWARD_AVAILABLE) return (
        <Tooltip
            id={id}
        >
            <p className={styles['tooltip-subtitle']}>
                {DONE}
            </p>
            <p className={styles['tooltip-message']}>
                {DONE_DESCRIPTION}
            </p>
        </Tooltip>
    )

    if (status === QUEST_STATUSES.REWARD_PENDING) return (
        <Tooltip
            id={id}
        >
            <p className={styles['tooltip-message']}>
                {PENDING}
            </p>
        </Tooltip>
    )

    if (!isAvailable) return (
        <Tooltip
            id={id}
        >
            <p className={styles['tooltip-subtitle']}>
                {TASK_NOT_AVAILABLE}
            </p>
            <p className={styles['tooltip-message']}>
                { isLockedByPreviousCycle ?
                    TASK_TAKE_PREV_REWARD :
                    TASK_COMPLETE_PREVIOUS
                }
            </p>
        </Tooltip>
    )
})

QuestStatusTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    isAvailable: PropTypes.bool.isRequired,
    previousRewardsSum: PropTypes.number.isRequired,
    isLockedByPreviousCycle: PropTypes.bool.isRequired,
    status: PropTypes.oneOf(Object.values(QUEST_STATUSES)).isRequired,
}

export default QuestStatusTooltip



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyTooltips/QuestStatusTooltip.jsx